module.exports = __webpack_public_path__ + "static/media/k8.e69cd6c6.jpg";